module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qS0uKb/tc-custom/9781504066150.jpg?1728259374356",
      "alt": "This image is the cover for the book Keeper of the Bees"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Keeper of the Bees\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A wounded veteran discovers the healing power of nature in this classic American novel by the author of "), _c('i', [_vm._v("A Girl of the Limberlost")]), _vm._v(".")])]), _c('p', [_vm._v("Wounded in World War I, Jamie McFarlane is looking for a peaceful place to spend his final days. After escaping the grim confines of a California military hospital, he finds himself at the seaside home of the Bee Master. There, with the help of an impish eleven-year-old called Little Scout, Jamie tends to the hives and flowers while the Bee Master is away.")]), _vm._v(" As Jamie learns his new responsibilities, he discovers a source of hope and healing in the natural beauty that surrounds him. He also crosses paths with a mysterious young woman who faces a dilemma as dire as his own. This beloved tale of hardship, nature, and renewal is rich in wisdom and the joy of being alive.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gene Stratton-Porter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gene Stratton-Porter was born and raised in Wabash County, Indiana. She was a self-trained American author, nature photographer, and naturalist.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0